var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('div',{staticClass:"bto-sb-widget bto-sb-widget-banner"},[_c(_vm.link.component,_vm._b({tag:"component"},'component',_vm.link.props,false),[_c('img',{attrs:{"src":_vm.link.imgUrl ? _vm.link.imgUrl : _vm.defaultImg}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }